define('core/platformValidation',['exports'], function(platformValidation) {

    platformValidation.createValidityRule = function(ruleName, dispatcher) {

        var rule = {};
        rule[ruleName] = {
            settings: { async: true },
            test: function(value, optionalPayload) {

                var payload = value;

                if (optionalPayload !== undefined && optionalPayload !== null) {
                    payload = optionalPayload;
                }

                return dispatcher.validate(payload);
            }
        };
        return rule;

    };

});

